/**src\presentation\components\layout\Header\Header.tsx
 * Header Component
 *
 * Main application header with navigation.
 */

/** src/presentation/components/layout/Header/Header.tsx */

import styles from './Header.module.css';

interface HeaderProps {
  title: string;
  onMenuClick?: () => void;
}

export function Header({
  title,
  onMenuClick,
}: HeaderProps) {
  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <button
          type="button"
          className={styles.menuButton}
          onClick={onMenuClick}
          aria-label="Abrir menú"
        >
          ☰
        </button>

        <img
          src="/logo.png"
          alt="Logo"
          className={styles.logo}
        />

        <h1 className={styles.title}>
          {title}
        </h1>
      </div>
    </header>
  );
}
